// extracted by mini-css-extract-plugin
module.exports = {"AppLayout":"AppLayout_suyHs","AppLayoutContentFeedback":"AppLayoutContentFeedback_56Gim","AppLayoutContentWrap":"AppLayoutContentWrap_tLhu5"};